import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Spinner } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getSimulationTemplateList } from '../../../API/PhishingAPI';
import { groupTemplateSets, templateOrganization } from './templateOrganization';

export function SimulationTemplateSelect({ value = '', onChange, templates, t }) {
  const [items, setItems] = useState(templates || null);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    if (templates) { setItems(templates); return undefined; }
    let active = true;
    setError(false);
    getSimulationTemplateList().then(data => { if (active) setItems(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [templates, revision]);
  if (error) return <Alert color="danger">{t('template_gallery.my_error')}
    <Button color="link" onClick={() => setRevision(count => count + 1)}>{t('template_gallery.retry')}</Button></Alert>;
  if (!items) return <Spinner size="sm" />;
  const selected = items.find(item => String(item.id) === String(value));
  return <>
    <Input type="select" id="simulation-template-select" value={value} onChange={event => {
      onChange(items.find(item => String(item.id) === event.target.value));
    }}>
      <option value="">{t('template_gallery.select_set')}</option>
      {groupTemplateSets(items, t).map(group => <optgroup key={group.key} label={group.label}>
        {group.sets.map(item => <option key={item.id} value={item.id} disabled={!item.page} title={item.name}>
          {templateOrganization(item, t).title}{!item.page ? ` (${t('template_gallery.missing_page')})` : ''}
        </option>)}
      </optgroup>)}
    </Input>
    {selected?.page && <small className="d-block text-muted mt-2">
      {t('template_gallery.includes', { message: selected.message.name, page: selected.page.name })}
    </small>}
    {!items.some(item => item.page) && <Alert color="info" className="mt-2">{t('template_gallery.no_sets')}{' '}
      <Link to="/organization/phishing_simulator/templates">{t('template_gallery.create_set')}</Link>
    </Alert>}
  </>;
}

export default withTranslation()(SimulationTemplateSelect);
